import { useState } from 'react';
import classNames from 'classnames';
import moment from 'moment';
import close from '../../assets/images/close.png';
import styles from './EditEndAtModal.module.css';
import { updateFundraiserApi } from "../../api/fundraisers";
import addDaysToDate from "../../utils/addDaysToDate";
import Button from '../Button.jsx';
import FormDateInput from "../form/FormDateInput";
import FormButton from "../form/FormButton";
import FormError from "../form/FormError";

const EditEndAtModal = (props) => {
    const [formData, setFormData] = useState({
        endAt: props.fundraiser.end_at

    });
    const endAtTime = moment(props.fundraiser.end_at).local().format('HH:mm:ss');
    const initialErrorObject = {
        endAt: false
    };
    const [errorObject, setErrorObject] = useState(initialErrorObject);
    const inputsMessagesErrorObject = {
        endAt: 'Required',
    };
    const [editEndAtInProgress, setEditEndAtInProgress] = useState(false);

    const update = (value) => {
        const date = moment(value).format('YYYY-MM-DD');
        const datetime = moment(date + ' ' + endAtTime).toISOString();
        setFormData({...formData, endAt: datetime});
    };

    const checkForEmptyInputs = () => {
        setErrorObject(initialErrorObject);
        const newErrorObject = structuredClone(initialErrorObject);
        let foundError = false;
        for(const key of Object.keys(formData)){
            if(!formData[key]){
                newErrorObject[key] = inputsMessagesErrorObject[key];
                foundError = true;
            }
        }
        setErrorObject(newErrorObject);
        return foundError;
    };

    const submit = async(event) => {
        event.preventDefault();
        setErrorObject(initialErrorObject);
        setEditEndAtInProgress(true);
        if(checkForEmptyInputs()){
            setEditEndAtInProgress(false);
            return;
        }
        const editEndAtResponse = await updateFundraiserApi(props.fundraiser.id, 'end_at', formData.endAt);
        let body;
        try{
            body = await editEndAtResponse.json();
        }
        catch(e){}
        if(editEndAtResponse && editEndAtResponse.ok){
            props.updateFundraiserEndAt(body.data.change_history_id, formData.endAt);
            props.close();
        }
        else{
            const error = body?.error ? body.error : 'Update fundraiser end at failed';
            setErrorObject((prevState) => ({...prevState, apiError: error}));
        }
        setEditEndAtInProgress(false);
    };

    return (
        <div className={styles.modal}>
            <div className={styles.container}>
                <div className={styles.header}>
                    Edit end date
                </div>
                <img className={styles.close} src={close} alt="Close" onClick={props.close}/>
                <form className={styles.form} onSubmit={submit}>
                    <FormDateInput className={styles.input} label="End date" placeholder="mm/dd/yyyy" value={formData.endAt}
                                   update={(value) => update(value)}
                                   minDate={addDaysToDate(new Date(), 1)}
                                   maxDate={addDaysToDate(new Date(), 180)}
                                   error={errorObject.endAt} required/>
                    {
                        errorObject.apiError && (
                            <FormError error={errorObject.apiError}/>
                        )
                    }
                    <div className={classNames(styles.buttons, {[styles.buttonsApiError]: errorObject.apiError})}>
                        <Button className={styles.button} text="Cancel" onClick={props.close}/>
                        <FormButton className={styles.button} style={{marginLeft: 'auto'}} text="Update" disabled={editEndAtInProgress}/>
                    </div>
                </form>
            </div>
        </div>
    )
};

export default EditEndAtModal;